import * as S from './styles'
import { useTimelineContainer } from './useTimelineContainer'
import { Image, TextWithHighlighted } from '@/components'

export const TimelineContainer: React.FC = () => {
  const { fontSizes, timelineData } = useTimelineContainer()

  return (
    <S.TimelineContainer>
      <TextWithHighlighted
        size={fontSizes.title}
        className="title-timeline"
        text={timelineData.title}
      />
      <S.TimelineList>
        <div className="list">
          {timelineData.topics.map((topic) => (
            <div className="item" key={topic}>
              <TextWithHighlighted
                size={fontSizes.titleList}
                className="title-list"
                text={topic}
              />
            </div>
          ))}
        </div>
        <Image
          src="https://nh-site-strapi-bucket.s3.amazonaws.com/person_abcba5a863.png?updated_at=2023-05-31T16:07:48.779Z"
          alt="person"
          defaultSize={{
            height: 425,
            width: 425,
          }}
        />
      </S.TimelineList>
    </S.TimelineContainer>
  )
}
